import React, { useCallback, useEffect, useMemo } from "react"
import { Link } from "react-router-dom"
import { useSelector } from "react-redux"
import CommonSelect from "../../../core/common/commonSelect"
import MultiSelectSection from "../../../core/common/multiSelect"
import ImageWithBasePath from "../../../core/common/imageWithBasePath"
import { useState } from "react"
import {
  Driver,
  getAllDrivers,
  getShiftsByVehicle,
  getRoutesByVehicleAndShift,
  uploadDriverDocuments,
} from "../../../service/transport"
import { toast } from "react-toastify"
import { Van } from "../../../service/TransportVehicle/transportVehicle"
import { Option } from "../../../core/common/commonSelect"
import { createAllocation } from "../../../service/transportAssignVehicles"
import TransportStudentDropdown from "./TransportStudentDropdown"
import {
  getAllVans,
  uploadVanDocuments,
} from "../../../service/TransportVehicle/transportVehicle"
import { TransportAllocation } from "../../../service/transportAssignVehicles"
import { getAllContractors } from "../../../service/contractor"
import { getAllTransportShifts } from "../../../service/transportShift"
import { DEFAULT_BRANCH_ID } from "../../../constant"
import { selectCurrentSession } from "../../../core/data/redux/slice/sessionsSlice"
import Swal from "sweetalert2"

interface TransportModalProps {
  onAddDriver?: (driverData: any) => Promise<boolean | string>
  onDeleteDriver?: (driverId: string) => Promise<boolean>
  onEditDriver?: (driverId: string, driverData: any) => Promise<boolean>
  driverToDelete?: string | null
  setDriverToDelete?: (id: string | null) => void
  driverToEdit?: Driver | null
  setDriverToEdit?: (driver: Driver | null) => void
  onAddVan?: (vanData: any) => Promise<boolean | string>
  onEditVan?: (id: string, vanData: any) => Promise<boolean>
  onDeleteVan?: (vanId: string) => Promise<boolean>
  vanToEdit?: Van | null
  setVanToEdit?: (van: Van | null) => void
  vanToDelete?: string | null
  setVanToDelete?: (id: string | null) => void
  onAllocationCreated?: () => void
  onDeleteAllocation?: (allocationId: string) => Promise<boolean>
  allocationToDelete?: string | null
  setAllocationToDelete?: (id: string | null) => void
  onEditAllocation?: (
    allocationId: string,
    allocationData: any,
  ) => Promise<boolean>
  allocationToEdit?: TransportAllocation | null
  setAllocationToEdit?: (allocation: TransportAllocation | null) => void
  selectedSystem?: any
  disableClassAndStudent?: boolean
  preSelectedStudentId?: string | null
}
const TransportModal: React.FC<TransportModalProps> = ({
  onAddDriver,
  onDeleteDriver,
  onEditDriver,
  driverToDelete,
  setDriverToDelete,
  driverToEdit,
  setDriverToEdit,
  onAddVan,
  onAllocationCreated,
  onDeleteAllocation,
  allocationToDelete,
  setAllocationToDelete,
  onEditAllocation,
  allocationToEdit,
  setAllocationToEdit,
  onEditVan,
  onDeleteVan,
  vanToEdit,
  setVanToEdit,
  vanToDelete,
  setVanToDelete,
  selectedSystem,
  disableClassAndStudent = false,
  preSelectedStudentId = null,
}) => {
  const currentSession = useSelector(selectCurrentSession)
  const [drivers, setDrivers] = useState<
    { value: string; label: string; driverData: any }[]
  >([])
  const [loadingDrivers, setLoadingDrivers] = useState(false)
  const [routes, setRoutes] = useState<Option[]>([])
  const [contractors, setContractors] = useState<
    {
      value: string
      label: string
      areas?: Option[]
      contractorType?: string
    }[]
  >([])
  const [loadingContractors, setLoadingContractors] = useState(false)
  const [transportShifts, setTransportShifts] = useState<Option[]>([])
  const [loadingShifts, setLoadingShifts] = useState(false)
  type ShiftRoutePair = {
    shiftId: string
    shiftLabel: string
    routeValue: string
    routeLabel: string
  }
  type ShiftRoutePairAddVan = {
    shiftId: string
    shiftLabel: string
    routes: Option[]
  }
  const [shiftRoutePairs, setShiftRoutePairs] = useState<
    ShiftRoutePairAddVan[]
  >([{ shiftId: "", shiftLabel: "", routes: [] }])
  const [editShiftRoutePairs, setEditShiftRoutePairs] = useState<
    ShiftRoutePair[]
  >([])
  const [editStudentOption, setEditStudentOption] = useState<{
    value: string
    label: string
  } | null>(null)
  const [loading, setLoading] = useState(false)
  const [selectedVan, setSelectedVan] = useState<any>(null)
  const [selectedPickupPoint, setSelectedPickupPoint] = useState<Option | null>(
    null,
  )
  const [allVans, setAllVans] = useState<
    { value: string; label: string; vanData: any }[]
  >([])
  const [vans, setVans] = useState<
    { value: string; label: string; vanData: any }[]
  >([])
  const [allocationForm, setAllocationForm] = useState({
    vanId: "",
    driverId: "",
    pickupStop: "",
  })
  const [allocationVehicleId, setAllocationVehicleId] = useState("")
  const [allocationShiftId, setAllocationShiftId] = useState("")
  const [allocationRoute, setAllocationRoute] = useState("")
  const [allocationDriverId, setAllocationDriverId] = useState("")
  const [shiftsForAllocationVehicle, setShiftsForAllocationVehicle] = useState<
    Option[]
  >([])
  const [routesForAllocationVehicleShift, setRoutesForAllocationVehicleShift] =
    useState<Option[]>([])
  const [driversForAllocationVehicle, setDriversForAllocationVehicle] =
    useState<Option[]>([])
  const [loadingAllocationShifts, setLoadingAllocationShifts] = useState(false)
  const [loadingAllocationRoutes, setLoadingAllocationRoutes] = useState(false)
  const [allDriversWithAssignments, setAllDriversWithAssignments] = useState<
    any[]
  >([])
  const [allocationStudentId, setAllocationStudentId] = useState<string>("")
  const [allocationFeeAmount, setAllocationFeeAmount] = useState<string>("")
  const [isAssigning, setIsAssigning] = useState(false)
  const [isEditing, setIsEditing] = useState(false)
  const [allocationStudentBranch, setAllocationStudentBranch] = useState<string>("")
  const [allocationStudentSystem, setAllocationStudentSystem] = useState<string>("")
  const [editAllocationForm, setEditAllocationForm] = useState({
    studentId: "",
    vanId: "",
    driverId: "",
    pickupStop: "",
    status: "active" as "active" | "inactive",
    feeAmount: "" as string | number,
  })

  const [editVanForm, setEditVanForm] = useState({
    contractor: "",
    registration_number: "",
    model: "",
    capacity: 0,
    chassis_number: "",
    engine_number: "",
    route_name: "",
    driver: "",
    status: "active" as "active" | "maintenance" | "inactive",
  })

  useEffect(() => {
    const onModalShow = (event: any) => {
      const id = event?.target?.id
      if (id === "add_assign_vehicle") {
        getAllDrivers({ limit: 500 })
          .then(res => setAllDriversWithAssignments(res?.data || []))
          .catch(() => setAllDriversWithAssignments([]))
        if (preSelectedStudentId && disableClassAndStudent) {
          setAllocationStudentId(preSelectedStudentId)
        } else {
          setAllocationForm({ vanId: "", driverId: "", pickupStop: "" })
          setSelectedVan(null)
          setSelectedPickupPoint(null)
          setAllocationVehicleId("")
          setAllocationShiftId("")
          setAllocationRoute("")
          setAllocationDriverId("")
          setShiftsForAllocationVehicle([])
          setRoutesForAllocationVehicleShift([])
          setDriversForAllocationVehicle([])
          setAllocationStudentId("")
          setAllocationFeeAmount("")
        }
      } else if (id === "add_vehicle") {
        setVanForm({
          contractor: "",
          registration_number: "",
          model: "",
          capacity: 0,
          chassis_number: "",
          engine_number: "",
          route_name: "",
          driver: "",
          status: "active",
        })
        setVanDocFiles({ carRegistration: null })
        setRoutes([])
        setShiftRoutePairs([{ shiftId: "", shiftLabel: "", routes: [] }])
      }
    }

    const modalAssign = document.getElementById("add_assign_vehicle")
    const modalVan = document.getElementById("add_vehicle")
    modalAssign?.addEventListener("show.bs.modal", onModalShow)
    modalVan?.addEventListener("show.bs.modal", onModalShow)
    return () => {
      modalAssign?.removeEventListener("show.bs.modal", onModalShow)
      modalVan?.removeEventListener("show.bs.modal", onModalShow)
    }
  }, [preSelectedStudentId, disableClassAndStudent])

  useEffect(() => {
    if (!allocationVehicleId) {
      setShiftsForAllocationVehicle([])
      setAllocationShiftId("")
      setAllocationRoute("")
      setAllocationDriverId("")
      setRoutesForAllocationVehicleShift([])
      setDriversForAllocationVehicle([])
      return
    }
    setLoadingAllocationShifts(true)
    setAllocationShiftId("")
    setAllocationRoute("")
    setAllocationDriverId("")
    setRoutesForAllocationVehicleShift([])
    getShiftsByVehicle(allocationVehicleId)
      .then(shifts => {
        setShiftsForAllocationVehicle(
          (shifts || []).map((s: any) => ({
            value: s._id || s.id,
            label: s.name || s.transportShiftId || s._id,
          })),
        )
      })
      .catch(() => setShiftsForAllocationVehicle([]))
      .finally(() => setLoadingAllocationShifts(false))
  }, [allocationVehicleId])

  useEffect(() => {
    const isEditPrefill =
      allocationToEdit && allocationVehicleId === allocationToEdit.van?._id
    if (!isEditPrefill) {
      setAllocationDriverId("")
    }

    if (!allocationVehicleId) {
      setDriversForAllocationVehicle([])
      return
    }
    const filtered = (allDriversWithAssignments || []).filter((d: any) =>
      (d.assignments || []).some(
        (a: any) =>
          (a.vehicleId?._id || a.vehicleId) === allocationVehicleId &&
          (a.route || "").trim() === (allocationRoute || "").trim(),
      ),
    )
    let driverOptions = filtered.map((d: any) => ({
      value: d._id,
      label:
        `${d.first_name || ""} ${d.last_name || ""}`.trim() ||
        d.driverID ||
        d._id,
    }))

    const editDriverId =
      isEditPrefill && allocationToEdit?.driver
        ? (allocationToEdit.driver as any)?._id ||
          (allocationToEdit.driver as any)?.id
        : null
    if (
      isEditPrefill &&
      editDriverId &&
      !driverOptions.some((d: any) => d.value === editDriverId)
    ) {
      const editDriver = (allDriversWithAssignments || []).find(
        (d: any) => d._id === editDriverId,
      )
      if (editDriver) {
        driverOptions = [
          {
            value: editDriver._id,
            label:
              `${editDriver.first_name || ""} ${editDriver.last_name || ""}`.trim() ||
              editDriver.driverID ||
              editDriver._id,
          },
          ...driverOptions,
        ]
      }
    }

    setDriversForAllocationVehicle(driverOptions)

    if (isEditPrefill && editDriverId) {
      if (driverOptions.some((d: any) => d.value === editDriverId)) {
        setAllocationDriverId(editDriverId)
      }
    } else if (driverOptions.length === 1) {
      setAllocationDriverId(driverOptions[0].value)
    }
  }, [
    allocationVehicleId,
    allocationRoute,
    allDriversWithAssignments,
    allocationToEdit,
  ])

  useEffect(() => {
    if (!allocationVehicleId || !allocationShiftId) {
      setRoutesForAllocationVehicleShift([])
      setAllocationRoute("")
      return
    }
    setLoadingAllocationRoutes(true)
    setAllocationRoute("")
    getRoutesByVehicleAndShift(allocationVehicleId, allocationShiftId)
      .then(routes => {
        setRoutesForAllocationVehicleShift(
          (routes || []).map((r: string) => ({ value: r, label: r })),
        )
      })
      .catch(() => setRoutesForAllocationVehicleShift([]))
      .finally(() => setLoadingAllocationRoutes(false))
  }, [allocationVehicleId, allocationShiftId])

  useEffect(() => {
    if (
      !allocationToEdit ||
      allocationVehicleId !== allocationToEdit.van?._id ||
      shiftsForAllocationVehicle.length === 0 ||
      allocationShiftId !== ""
    )
      return
    setAllocationShiftId(shiftsForAllocationVehicle[0].value)
  }, [
    allocationToEdit,
    allocationVehicleId,
    allocationShiftId,
    shiftsForAllocationVehicle,
  ])

  useEffect(() => {
    if (
      !allocationToEdit ||
      allocationVehicleId !== allocationToEdit.van?._id ||
      routesForAllocationVehicleShift.length === 0
    )
      return
    const pickupStop = allocationToEdit.pickupStop?.trim() || ""
    const match = routesForAllocationVehicleShift.find(
      (r: any) =>
        (r.label || "").trim() === pickupStop ||
        (r.value || "").trim() === pickupStop,
    )
    const value =
      match?.value ?? routesForAllocationVehicleShift[0]?.value ?? pickupStop
    if (value && allocationRoute !== value) {
      setAllocationRoute(value)
    }
  }, [allocationToEdit, allocationVehicleId, routesForAllocationVehicleShift])

  useEffect(() => {
    setAllocationForm(prev => ({
      ...prev,
      vanId: allocationVehicleId,
      driverId: allocationDriverId,
      pickupStop: allocationRoute,
    }))
  }, [allocationVehicleId, allocationDriverId, allocationRoute])

  useEffect(() => {
    if (vanToEdit && vanToEdit._id) {
      setVanDocFiles({ carRegistration: null })
      setExistingRegImageUrl((vanToEdit as any).registrationImage ?? null)
      const routeNameString = Array.isArray(vanToEdit.route_name)
        ? vanToEdit.route_name.map(route => route.name).join(", ")
        : ""
      const apiShiftRoutes = (vanToEdit as any).shiftRoutes as
        | {
            shiftId?: { _id?: string; name?: string } | string
            route?: string
          }[]
        | undefined
      const legacyShiftRoutes = (vanToEdit as any).shift_routes as
        | { shiftId?: string; shiftName?: string; routeName?: string }[]
        | undefined
      const shiftRoutes =
        Array.isArray(apiShiftRoutes) && apiShiftRoutes.length > 0
          ? apiShiftRoutes
          : Array.isArray(legacyShiftRoutes)
            ? legacyShiftRoutes.map(sr => ({
                shiftId: sr.shiftId,
                shiftName: sr.shiftName,
                routeName: sr.routeName,
                route: sr.routeName,
              }))
            : []
      let pairs: ShiftRoutePair[] = []
      if (Array.isArray(shiftRoutes) && shiftRoutes.length > 0) {
        pairs = shiftRoutes.map((sr: any) => {
          const shiftIdObj = sr.shiftId
          const shiftId =
            typeof shiftIdObj === "string"
              ? shiftIdObj
              : (shiftIdObj?._id ?? "")
          const shiftLabel =
            typeof shiftIdObj === "object" && shiftIdObj?.name != null
              ? shiftIdObj.name
              : (sr.shiftName ?? "")
          const routeStr = sr.route ?? sr.routeName ?? ""
          return {
            shiftId,
            shiftLabel,
            routeValue: routeStr,
            routeLabel: routeStr,
          }
        })
      } else if (
        Array.isArray(vanToEdit.route_name) &&
        vanToEdit.route_name.length > 0
      ) {
        pairs = vanToEdit.route_name.map((route: { name?: string }) => {
          const name = route.name ?? ""
          return {
            shiftId: "",
            shiftLabel: "",
            routeValue: name,
            routeLabel: name,
          }
        })
      } else {
        pairs = [
          { shiftId: "", shiftLabel: "", routeValue: "", routeLabel: "" },
        ]
      }

      setEditVanForm({
        contractor:
          (vanToEdit as any).contractorId?._id ??
          (vanToEdit as any).contractor?._id ??
          (vanToEdit as any).contractorId ??
          (vanToEdit as any).contractor ??
          "",
        registration_number:
          vanToEdit.registration_number ?? (vanToEdit as any).vehicleNo ?? "",
        model: vanToEdit.model ?? (vanToEdit as any).maker ?? "",
        capacity: vanToEdit.capacity ?? 0,
        chassis_number:
          (vanToEdit as any).chassisNo ??
          (vanToEdit as any).chassis_number ??
          "",
        engine_number:
          (vanToEdit as any).engineNo ?? (vanToEdit as any).engine_number ?? "",
        route_name: routeNameString,
        driver: vanToEdit.driver_id || vanToEdit.driver?._id || "",
        status: vanToEdit.status || "active",
      })
      setRoutes(
        Array.isArray(vanToEdit.route_name)
          ? vanToEdit.route_name.map(route => ({
              value: route.name ?? "",
              label: route.name ?? "",
            }))
          : [],
      )
      setEditShiftRoutePairs(pairs)
    }
  }, [vanToEdit, drivers])

  const driversForEditVanByRoute = useMemo(() => {
    const selectedRoutes = editShiftRoutePairs
      .map(p => (p.routeLabel || "").trim())
      .filter(Boolean)
    if (selectedRoutes.length === 0) return []
    return drivers.filter(d =>
      (d.driverData?.assignments || []).some((a: any) =>
        selectedRoutes.includes((a.route || "").trim()),
      ),
    )
  }, [drivers, editShiftRoutePairs])

  interface DriverForm {
    first_name: string
    last_name: string
    contact_number: string
    license_number: string
    cnic?: string
    address: string
    status: string
    joining_date: string
  }

  type DriverAssignmentRow = {
    vehicleId: string
    shiftId: string
    routes: string[]
    vehicleLabel?: string
    shiftLabel?: string
  }

  const [driverAddSubmitting, setDriverAddSubmitting] = useState(false)
  const [driverForm, setDriverForm] = useState<DriverForm>({
    first_name: "",
    last_name: "",
    contact_number: "",
    license_number: "",
    cnic: "",
    address: "",
    status: "active",
    joining_date: "",
  })
  const [driverDocFiles, setDriverDocFiles] = useState<{
    drivingLicense: File | null
    cnic: File | null
  }>({ drivingLicense: null, cnic: null })
  const [vanDocFiles, setVanDocFiles] = useState<{
    carRegistration: File | null
  }>({ carRegistration: null })
  const [existingRegImageUrl, setExistingRegImageUrl] = useState<string | null>(null)
  const [driverVehicles, setDriverVehicles] = useState<Option[]>([])
  const [loadingDriverVehicles, setLoadingDriverVehicles] = useState(false)
  const [assignmentRows, setAssignmentRows] = useState<DriverAssignmentRow[]>([
    { vehicleId: "", shiftId: "", routes: [] },
  ])
  const [shiftsCache, setShiftsCache] = useState<Record<string, Option[]>>({})
  const [loadingShiftsForVehicleId, setLoadingShiftsForVehicleId] = useState<
    string | null
  >(null)
  const [loadingRoutesForKey, setLoadingRoutesForKey] = useState<string | null>(
    null,
  )

  const [editDriverForm, setEditDriverForm] = useState<DriverForm>({
    first_name: "",
    last_name: "",
    contact_number: "",
    license_number: "",
    cnic: "",
    address: "",
    status: "active",
    joining_date: "",
  })
  const [editAssignmentRows, setEditAssignmentRows] = useState<
    DriverAssignmentRow[]
  >([])
  const [editShiftsCache, setEditShiftsCache] = useState<
    Record<string, Option[]>
  >({})
  const [loadingEditShiftsForVehicleId, setLoadingEditShiftsForVehicleId] =
    useState<string | null>(null)
  const [loadingEditRoutesForKey, setLoadingEditRoutesForKey] = useState<
    string | null
  >(null)

  useEffect(() => {
    const loadDriverVehicles = async () => {
      setLoadingDriverVehicles(true)
      try {
        const res = await getAllVans({ page: 1, limit: 500, status: "active" })
        const list = res?.data ?? []
        setDriverVehicles(
          list.map((v: any) => ({
            value: v._id || v.key,
            label: v.vehicleNo || v.registration_number || v.vanId || v._id,
          })),
        )
      } catch {
        setDriverVehicles([])
      } finally {
        setLoadingDriverVehicles(false)
      }
    }
    loadDriverVehicles()
  }, [])

  const updateAssignmentRow = (
    index: number,
    updates: Partial<DriverAssignmentRow>,
  ) => {
    setAssignmentRows(prev => {
      const next = [...prev]
      next[index] = { ...next[index], ...updates }
      return next
    })
  }

  const handleAssignmentVehicleChange = (index: number, vehicleId: string) => {
    const vehicleOpt = driverVehicles.find(v => v.value === vehicleId)
    updateAssignmentRow(index, {
      vehicleId,
      shiftId: "",
      routes: [],
      vehicleLabel: vehicleOpt?.label,
      shiftLabel: undefined,
    })
    if (!vehicleId) return
    setLoadingShiftsForVehicleId(vehicleId)
    getShiftsByVehicle(vehicleId)
      .then(shifts => {
        setShiftsCache(c => ({
          ...c,
          [vehicleId]: (shifts || []).map((s: any) => ({
            value: s._id || s.id,
            label: s.name || s.transportShiftId || s._id,
          })),
        }))
      })
      .catch(() => setShiftsCache(c => ({ ...c, [vehicleId]: [] })))
      .finally(() => setLoadingShiftsForVehicleId(null))
  }

  const handleAssignmentShiftChange = (index: number, shiftId: string) => {
    const row = assignmentRows[index]
    const shiftOpt = (shiftsCache[row?.vehicleId] ?? []).find(
      s => s.value === shiftId,
    )
    updateAssignmentRow(index, {
      shiftId,
      shiftLabel: shiftOpt?.label,
      routes: [],
    })
    if (!row?.vehicleId || !shiftId) return
    const key = `${row.vehicleId}-${shiftId}`
    setLoadingRoutesForKey(key)
    getRoutesByVehicleAndShift(row.vehicleId, shiftId)
      .then(fetched => {
        updateAssignmentRow(index, { routes: fetched || [] })
      })
      .catch(() => updateAssignmentRow(index, { routes: [] }))
      .finally(() => setLoadingRoutesForKey(null))
  }

  const handleAddAssignmentRow = () => {
    setAssignmentRows(prev => [
      ...prev,
      { vehicleId: "", shiftId: "", routes: [] },
    ])
  }

  const handleRemoveAssignment = (index: number) => {
    setAssignmentRows(prev =>
      prev.length <= 1 ? prev : prev.filter((_, i) => i !== index),
    )
  }

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target
    setDriverForm((prev: DriverForm) => ({
      ...prev,
      [name as keyof DriverForm]: value,
    }))
  }

  const isValidCnic = (v: string) =>
    /^\d{13}$/.test(String(v).replace(/\D/g, ""))
  const isValidPhone = (v: string) => {
    const digits = String(v || "").replace(/\D/g, "")
    return digits.length >= 10 && digits.length <= 15
  }

  const handleSubmit = async () => {
    if (!onAddDriver) return
    if (!driverForm.first_name?.trim()) {
      toast.error("Enter driver name (first name).")
      return
    }
    if (!driverForm.contact_number?.trim()) {
      toast.error("Enter phone number.")
      return
    }
    if (!isValidPhone(driverForm.contact_number)) {
      toast.error("Phone number must be 10–15 digits.")
      return
    }
    if (!driverForm.cnic?.trim()) {
      toast.error("Enter CNIC.")
      return
    }
    if (!isValidCnic(driverForm.cnic)) {
      toast.error("CNIC must be 13 digits (e.g. 3520212345671).")
      return
    }
    if (!driverForm.address?.trim()) {
      toast.error("Enter address.")
      return
    }
    const validRows = assignmentRows.filter(
      r => r.vehicleId && r.shiftId && r.routes.length > 0,
    )
    if (validRows.length === 0) {
      toast.error(
        "Add at least one assignment — select Vehicle and Shift (routes auto-populate).",
      )
      return
    }
    const seen = new Set<string>()
    for (const r of validRows) {
      const key = `${r.vehicleId}-${r.shiftId}`
      if (seen.has(key)) {
        toast.error("Duplicate vehicle–shift assignment.")
        return
      }
      seen.add(key)
    }
    const payload = {
      ...driverForm,
      cnic_number: driverForm.cnic?.replace(/\D/g, "").slice(0, 13),
      assignments: validRows.flatMap(r =>
        r.routes.map(route => ({
          vehicleId: r.vehicleId,
          shiftId: r.shiftId,
          route,
        })),
      ),
      joining_date: driverForm.joining_date || undefined,
    }
    setDriverAddSubmitting(true)
    try {
      const result = await onAddDriver(payload)
      if (result) {
        const driverId = typeof result === "string" ? result : null
        if (driverId && (driverDocFiles.drivingLicense || driverDocFiles.cnic)) {
          try {
            const fd = new FormData()
            if (driverDocFiles.drivingLicense)
              fd.append("drivingLicense", driverDocFiles.drivingLicense)
            if (driverDocFiles.cnic) fd.append("cnic", driverDocFiles.cnic)
            await uploadDriverDocuments(driverId, fd)
          } catch (err: any) {
            toast.error(
              err?.response?.data?.message ||
                err?.message ||
                "Driver documents upload failed",
            )
          }
        }
        setDriverForm({
          first_name: "",
          last_name: "",
          contact_number: "",
          license_number: "",
          cnic: "",
          address: "",
          status: "active",
          joining_date: "",
        })
        setDriverDocFiles({ drivingLicense: null, cnic: null })
        setAssignmentRows([{ vehicleId: "", shiftId: "", routes: [] }])
        setShiftsCache({})
        const closeButton = document.querySelector(
          '#add_driver [data-bs-dismiss="modal"]',
        ) as HTMLElement | null
        if (closeButton) closeButton.click()
      }
    } finally {
      setDriverAddSubmitting(false)
    }
  }

  useEffect(() => {
    if (driverToEdit) {
      setDriverDocFiles({ drivingLicense: null, cnic: null })
      const nameParts = (driverToEdit.name || "").split(" ")
      const firstName = nameParts[0] || ""
      const lastName = nameParts.slice(1).join(" ") || ""
      setEditDriverForm({
        first_name: firstName,
        last_name: lastName,
        contact_number: driverToEdit.phone || "",
        license_number: driverToEdit.driverLicenseNo || "",
        cnic: driverToEdit.cnic ?? (driverToEdit as any).cnic_number ?? "",
        address: driverToEdit.address || "",
        status: driverToEdit.status || "active",
        joining_date: (driverToEdit as any).joining_date
          ? String((driverToEdit as any).joining_date).slice(0, 10)
          : "",
      })
      const raw = (driverToEdit as any).assignments
      // Group by vehicleId+shiftId to merge routes into a single row per assignment
      const grouped = new Map<string, DriverAssignmentRow>()
      if (Array.isArray(raw)) {
        raw.forEach((a: any) => {
          const vid = a.vehicleId?._id ?? a.vehicleId ?? ""
          const sid = a.shiftId?._id ?? a.shiftId ?? ""
          const mapKey = `${vid}-${sid}`
          if (!grouped.has(mapKey)) {
            grouped.set(mapKey, {
              vehicleId: vid,
              shiftId: sid,
              routes: [],
              vehicleLabel:
                a.vehicleId?.vehicleNo ?? a.vehicleId?.vanId ?? vid,
              shiftLabel: a.shiftId?.name ?? sid,
            })
          }
          const route = typeof a.route === "string" ? a.route : ""
          if (route) grouped.get(mapKey)!.routes.push(route)
        })
      }
      const rows: DriverAssignmentRow[] = Array.from(grouped.values())
      setEditAssignmentRows(
        rows.length ? rows : [{ vehicleId: "", shiftId: "", routes: [] }],
      )
      setEditShiftsCache({})
      const vehicleIds = Array.from(
        new Set(
          rows.map((r: DriverAssignmentRow) => r.vehicleId).filter(Boolean),
        ),
      )
      vehicleIds.forEach((vid: string) => {
        getShiftsByVehicle(vid)
          .then(shifts => {
            setEditShiftsCache(prev => ({
              ...prev,
              [vid]: (shifts || []).map((s: any) => ({
                value: s._id || s.id,
                label: s.name || s.transportShiftId || s._id,
              })),
            }))
          })
          .catch(() => {})
      })
    }
  }, [driverToEdit])

  const updateEditAssignmentRow = (
    index: number,
    updates: Partial<DriverAssignmentRow>,
  ) => {
    setEditAssignmentRows(prev => {
      const next = [...prev]
      next[index] = { ...next[index], ...updates }
      return next
    })
  }

  const handleEditAssignmentVehicleChange = (
    index: number,
    vehicleId: string,
  ) => {
    const vehicleOpt = driverVehicles.find(v => v.value === vehicleId)
    updateEditAssignmentRow(index, {
      vehicleId,
      shiftId: "",
      routes: [],
      vehicleLabel: vehicleOpt?.label,
      shiftLabel: undefined,
    })
    if (!vehicleId) return
    setLoadingEditShiftsForVehicleId(vehicleId)
    getShiftsByVehicle(vehicleId)
      .then(shifts => {
        setEditShiftsCache(c => ({
          ...c,
          [vehicleId]: (shifts || []).map((s: any) => ({
            value: s._id || s.id,
            label: s.name || s.transportShiftId || s._id,
          })),
        }))
      })
      .catch(() => setEditShiftsCache(c => ({ ...c, [vehicleId]: [] })))
      .finally(() => setLoadingEditShiftsForVehicleId(null))
  }

  const handleEditAssignmentShiftChange = (index: number, shiftId: string) => {
    const row = editAssignmentRows[index]
    const shiftOpt = (editShiftsCache[row?.vehicleId] ?? []).find(
      s => s.value === shiftId,
    )
    updateEditAssignmentRow(index, {
      shiftId,
      shiftLabel: shiftOpt?.label,
      routes: [],
    })
    if (!row?.vehicleId || !shiftId) return
    const key = `${row.vehicleId}-${shiftId}`
    setLoadingEditRoutesForKey(key)
    getRoutesByVehicleAndShift(row.vehicleId, shiftId)
      .then(fetched => {
        updateEditAssignmentRow(index, { routes: fetched || [] })
      })
      .catch(() => updateEditAssignmentRow(index, { routes: [] }))
      .finally(() => setLoadingEditRoutesForKey(null))
  }

  const handleAddEditAssignmentRow = () => {
    setEditAssignmentRows(prev => [
      ...prev,
      { vehicleId: "", shiftId: "", routes: [] },
    ])
  }

  const handleRemoveEditAssignment = (index: number) => {
    setEditAssignmentRows(prev =>
      prev.length <= 1 ? prev : prev.filter((_, i) => i !== index),
    )
  }

  const handleEditInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target
    setEditDriverForm((prev: DriverForm) => ({
      ...prev,
      [name as keyof DriverForm]: value,
    }))
  }

  const handleEditSubmit = async () => {
    if (!onEditDriver || !driverToEdit) return
    if (!editDriverForm.contact_number?.trim()) {
      toast.error("Enter phone number.")
      return
    }
    if (!isValidPhone(editDriverForm.contact_number)) {
      toast.error("Phone number must be 10–15 digits.")
      return
    }
    if (
      editDriverForm.cnic != null &&
      editDriverForm.cnic !== "" &&
      !isValidCnic(editDriverForm.cnic)
    ) {
      toast.error("CNIC must be 13 digits.")
      return
    }
    const validEditRows = editAssignmentRows.filter(
      r => r.vehicleId && r.shiftId && r.routes.length > 0,
    )
    if (validEditRows.length === 0) {
      toast.error(
        "Driver must have at least one assignment — select Vehicle and Shift (routes auto-populate).",
      )
      return
    }
    const seenEdit = new Set<string>()
    for (const r of validEditRows) {
      const key = `${r.vehicleId}-${r.shiftId}`
      if (seenEdit.has(key)) {
        toast.error("Duplicate vehicle–shift assignment.")
        return
      }
      seenEdit.add(key)
    }
    const payload: any = {
      ...editDriverForm,
      assignments: validEditRows.flatMap(r =>
        r.routes.map(route => ({
          vehicleId: r.vehicleId,
          shiftId: r.shiftId,
          route,
        })),
      ),
      joining_date: editDriverForm.joining_date || undefined,
    }
    if (editDriverForm.cnic?.trim())
      payload.cnic_number = editDriverForm.cnic.replace(/\D/g, "").slice(0, 13)
    const success = await onEditDriver(driverToEdit.key, payload)
    if (success) {
      if (driverDocFiles.drivingLicense || driverDocFiles.cnic) {
        try {
          const fd = new FormData()
          if (driverDocFiles.drivingLicense)
            fd.append("drivingLicense", driverDocFiles.drivingLicense)
          if (driverDocFiles.cnic) fd.append("cnic", driverDocFiles.cnic)
          await uploadDriverDocuments(driverToEdit.key, fd)
        } catch (err: any) {
          toast.error(
            err?.response?.data?.message ||
              err?.message ||
              "Driver documents upload failed",
          )
        }
      }
      setDriverDocFiles({ drivingLicense: null, cnic: null })
      if (setDriverToEdit) setDriverToEdit(null)
    }
  }
  const handleDeleteConfirm = async () => {
    if (onDeleteDriver && driverToDelete && setDriverToDelete) {
      const success = await onDeleteDriver(driverToDelete)
      if (success) {
        setDriverToDelete(null)
      }
    }
    if (onDeleteVan && vanToDelete && setVanToDelete) {
      const success = await onDeleteVan(vanToDelete)
      if (success) {
        setVanToDelete(null)
      }
    }
    if (onDeleteAllocation && allocationToDelete && setAllocationToDelete) {
      const success = await onDeleteAllocation(allocationToDelete)
      if (success) {
        setAllocationToDelete(null)
        if (onAllocationCreated) {
          onAllocationCreated()
        }
      }
    }
  }

  useEffect(() => {
    fetchDrivers()
    fetchAllocationData()
  }, [])

  const fetchDrivers = async () => {
    setLoadingDrivers(true)
    try {
      const response = await getAllDrivers({
        searchText: "",
        status: "active",
        sortBy: "first_name",
        sortOrder: "asc",
      })

      if (response.data) {
        const driversOptions = response.data.map((driver: any) => ({
          value: driver._id || driver.id,
          label: `${driver.first_name} ${driver.last_name} - ${driver.license_number}`,
          driverData: driver,
        }))
        setDrivers(driversOptions)
      }
    } catch (error) {
      toast.error("Failed to load drivers")
    } finally {
      setLoadingDrivers(false)
    }
  }

  interface VanForm {
    contractor: string
    registration_number: string
    model: string
    capacity: number | ""
    chassis_number: string
    engine_number: string
    route_name: string
    driver: string
    status: "active" | "maintenance" | "inactive"
  }

  const [vanAddSubmitting, setVanAddSubmitting] = useState(false)
  const [vanEditSubmitting, setVanEditSubmitting] = useState(false)

  const [vanForm, setVanForm] = useState<VanForm>({
    contractor: "",
    registration_number: "",
    model: "",
    capacity: 0,
    chassis_number: "",
    engine_number: "",
    route_name: "",
    driver: "",
    status: "active" as "active" | "maintenance" | "inactive",
  })

  const routeOptionsForAddVan: Option[] = useMemo(() => {
    const selected = contractors.find(c => c.value === vanForm.contractor)
    if (!selected || !selected.areas || selected.areas.length === 0) return []
    return selected.areas
  }, [contractors, vanForm.contractor])

  const routeOptionsForEditVan: Option[] = useMemo(() => {
    const selected = contractors.find(c => c.value === editVanForm.contractor)
    if (!selected || !selected.areas || selected.areas.length === 0) return []
    return selected.areas
  }, [contractors, editVanForm.contractor])

  const handleVanInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target

    if (name === "capacity") {
      const num = Number(value)
      setVanForm(prev => ({
        ...prev,
        capacity: value === "" ? "" : num < 0 ? 0 : num,
      }))
      return
    }

    setVanForm(prev => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleDriverSelect = (selectedOption: any) => {
    const driverId = selectedOption?.value || ""

    setVanForm(prev => ({
      ...prev,
      driver: driverId,
    }))

    if (selectedOption && selectedOption.driverData) {
      const driver = selectedOption.driverData

      setVanForm(prev => ({
        ...prev,
        driver_license: driver.license_number || "",
        driver_contact: driver.contact_number || "",
        driver_address: driver.address || "",
      }))
    } else {
      setVanForm(prev => ({
        ...prev,
        driver_license: "",
        driver_contact: "",
        driver_address: "",
      }))
    }
  }

  const handleEditDriverSelect = (selectedOption: any) => {
    const driverId = selectedOption?.value || ""

    setEditVanForm(prev => ({
      ...prev,
      driver: driverId,
    }))
  }

  const addShiftRouteRow = () => {
    setShiftRoutePairs(prev => [
      ...prev,
      { shiftId: "", shiftLabel: "", routes: [] },
    ])
  }

  const removeShiftRouteRow = (index: number) => {
    setShiftRoutePairs(prev =>
      prev.length <= 1 ? prev : prev.filter((_, i) => i !== index),
    )
  }

  const handleShiftRoutePairChange = (
    index: number,
    field: "shift" | "route",
    value: Option | Option[] | null,
  ) => {
    setShiftRoutePairs(prev => {
      const next = [...prev]
      if (field === "shift") {
        next[index] = {
          ...next[index],
          shiftId: (value as Option)?.value ?? "",
          shiftLabel: (value as Option)?.label ?? "",
        }
      } else {
        const routeOpts = Array.isArray(value) ? value : value ? [value] : []
        next[index] = {
          ...next[index],
          routes: routeOpts,
        }
      }
      return next
    })
  }

  const handleVanSubmit = async () => {
    if (!onAddVan) {
      toast.error("Van add function not available")
      return
    }
    setVanAddSubmitting(true)

    if (!vanForm.contractor) {
      toast.error("Please select a Contractor")
      return
    }

    if (!vanDocFiles.carRegistration) {
      toast.error("Please upload Vehicle Registration document")
      return
    }

    const validPairs = shiftRoutePairs
      .flatMap(p =>
        (p.routes || []).map((r: Option) => ({
          shiftId: p.shiftId,
          shiftLabel: p.shiftLabel,
          routeValue: r.value,
          routeLabel: r.label,
        })),
      )
      .filter(p => p.routeValue && p.routeLabel)
    if (validPairs.length === 0) {
      toast.error("Please select at least one Shift and Route")
      return
    }

    try {
      const routeNameArray = validPairs.map(p => ({ name: p.routeLabel }))
      const shiftRoutes = validPairs.map(p => ({
        shiftId: p.shiftId,
        routeName: p.routeLabel,
      }))
      const vanData: any = {
        registration_number: vanForm.registration_number.trim(),
        model: vanForm.model.trim(),
        capacity: Number(vanForm.capacity || 0),
        route_name: routeNameArray,
        status: vanForm.status,
        driver: vanForm.driver || undefined,
      }
      vanData.contractor = vanForm.contractor
      if (vanForm.chassis_number?.trim())
        vanData.chassis_number = vanForm.chassis_number.trim()
      if (vanForm.engine_number?.trim())
        vanData.engine_number = vanForm.engine_number.trim()
      vanData.shift_routes = shiftRoutes

      const result = await onAddVan(vanData)
      if (result) {
        const vanId = typeof result === "string" ? result : null
        if (vanId && vanDocFiles.carRegistration) {
          try {
            const fd = new FormData()
            fd.append("carRegistration", vanDocFiles.carRegistration)
            await uploadVanDocuments(vanId, fd)
          } catch (err: any) {
            toast.error(
              err?.response?.data?.message ||
                err?.message ||
                "Vehicle documents upload failed",
            )
          }
        }
        setVanForm({
          contractor: "",
          registration_number: "",
          model: "",
          capacity: 0,
          chassis_number: "",
          engine_number: "",
          route_name: "",
          driver: "",
          status: "active",
        })
        setVanDocFiles({ carRegistration: null })
        setRoutes([])
        setShiftRoutePairs([{ shiftId: "", shiftLabel: "", routes: [] }])
      }
    } catch (error: any) {
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        "Failed to submit van form"
      toast.error(message)
    } finally {
      setVanAddSubmitting(false)
    }
  }

  useEffect(() => {
    const loadContractors = async () => {
      setLoadingContractors(true)
      try {
        const res = await getAllContractors({ status: "active", limit: 500 })
        if (res.data) {
          setContractors(
            res.data.map((c: any) => {
              // Backend may store contractor.area as:
              // - single comma-separated string: "Sindhi Muslim, Soldier Bazar, Sohail"
              // - array of strings (sometimes each already comma-joined)
              const rawArea = c.area
              const areaList: string[] = []

              if (Array.isArray(rawArea)) {
                rawArea.forEach((item: any) => {
                  if (typeof item === "string") {
                    item
                      .split(",")
                      .map((s: string) => s.trim())
                      .filter(Boolean)
                      .forEach(v => areaList.push(v))
                  }
                })
              } else if (typeof rawArea === "string") {
                rawArea
                  .split(",")
                  .map((s: string) => s.trim())
                  .filter(Boolean)
                  .forEach(v => areaList.push(v))
              }

              // Remove duplicates
              const uniqueAreas = Array.from(new Set(areaList))

              const areas: Option[] = uniqueAreas.map(a => ({ value: a, label: a }))

              const rawType =
                (c.contractorType ||
                  c.type ||
                  (c as any).contractor_type ||
                  "school") ??
                "school"
              const normalizedType = String(rawType).toLowerCase()

              return {
                value: c._id || c.id,
                label: c.name || c.identifier || c._id,
                areas,
                // Use backend contractorType (school/private) when available
                contractorType:
                  normalizedType === "private" ? "private" : "school",
              }
            }),
          )
        }
      } catch {
        toast.error("Failed to load contractors")
      } finally {
        setLoadingContractors(false)
      }
    }
    loadContractors()
  }, [])

  useEffect(() => {
    const loadShifts = async () => {
      setLoadingShifts(true)
      try {
        const res = await getAllTransportShifts({
          status: "active",
          limit: 500,
        })
        if (res.data) {
          setTransportShifts(
            res.data.map((s: any) => ({
              value: s._id || s.id,
              label: s.name || s.identifier || s._id,
            })),
          )
        }
      } catch {
        toast.error("Failed to load transport shifts")
      } finally {
        setLoadingShifts(false)
      }
    }
    loadShifts()
  }, [])


  const addEditShiftRouteRow = () => {
    setEditShiftRoutePairs(prev => [
      ...prev,
      { shiftId: "", shiftLabel: "", routeValue: "", routeLabel: "" },
    ])
  }

  const removeEditShiftRouteRow = (index: number) => {
    setEditShiftRoutePairs(prev =>
      prev.length <= 1 ? prev : prev.filter((_, i) => i !== index),
    )
  }

  const handleEditShiftRoutePairChange = (
    index: number,
    field: "shift" | "route",
    value: Option | null,
  ) => {
    setEditShiftRoutePairs(prev => {
      const next = [...prev]
      if (field === "shift") {
        next[index] = {
          ...next[index],
          shiftId: value?.value ?? "",
          shiftLabel: value?.label ?? "",
        }
      } else {
        next[index] = {
          ...next[index],
          routeValue: value?.value ?? "",
          routeLabel: value?.label ?? "",
        }
      }
      return next
    })
  }

  const handleEditVanInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target

    if (name === "capacity") {
      const num = Number(value)
      setEditVanForm(prev => ({
        ...prev,
        capacity: value === "" ? 0 : num < 0 ? 0 : num,
      }))
      return
    }

    setEditVanForm(prev => ({
      ...prev,
      [name]: name === "year" ? Number(value) : value,
    }))
  }

  const handleEditVanSubmit = async (e: React.FormEvent) => {
    e.preventDefault()

    if (!onEditVan || !vanToEdit) return

    try {
      if (editVanForm.status === "inactive") {
        const result = await Swal.fire({
          title: "Mark Vehicle as Inactive?",
          text: "If this vehicle has active student allocations, the change will be blocked.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, mark inactive",
          cancelButtonText: "Cancel",
        })
        if (!result.isConfirmed) return
      }

      const validPairs = editShiftRoutePairs.filter(
        p => p.routeValue && p.routeLabel,
      )
      if (validPairs.length === 0) {
        toast.error("Please select at least one Shift and Route")
        return
      }

      const routeNameArray = validPairs.map(p => ({ name: p.routeLabel }))
      const vanData: any = {
        registration_number: editVanForm.registration_number.trim(),
        model: editVanForm.model.trim(),
        capacity: Number(editVanForm.capacity),
        route_name: routeNameArray,
        status: editVanForm.status,
        // driver intentionally omitted — managed separately via driver assignment
      }
      if (editVanForm.contractor) vanData.contractor = editVanForm.contractor
      if (editVanForm.chassis_number?.trim())
        vanData.chassis_number = editVanForm.chassis_number.trim()
      if (editVanForm.engine_number?.trim())
        vanData.engine_number = editVanForm.engine_number.trim()
      vanData.shift_routes = validPairs.map(p => ({
        shiftId: p.shiftId,
        routeName: p.routeLabel,
      }))

      const success = await onEditVan(vanToEdit.key, vanData)
      if (success) {
        if (vanDocFiles.carRegistration) {
          try {
            const fd = new FormData()
            fd.append("carRegistration", vanDocFiles.carRegistration)
            await uploadVanDocuments(vanToEdit.key, fd)
          } catch (err: any) {
            toast.error(
              err?.response?.data?.message ||
                err?.message ||
                "Vehicle documents upload failed",
            )
          }
        }
        setVanDocFiles({ carRegistration: null })
        setExistingRegImageUrl(null)
        if (setVanToEdit) setVanToEdit(null)
      }
    } finally {
      setVanEditSubmitting(false)
    }
  }
  const handleCloseModal = () => {
    setExistingRegImageUrl(null)
    setVanDocFiles({ carRegistration: null })
    if (setVanToEdit) setVanToEdit(null)
  }

  const fetchAllocationData = async () => {
    setLoading(true)
    try {
      const vansRes = await getAllVans({ status: "active" })

      const vanOptions = vansRes.data.map((van: any) => {
        const registration =
          van.registration_number ||
          van.registrationNo ||
          van.registration_no ||
          van.registration ||
          ""
        return {
          value: van._id,
          label: [van.vanId, registration].filter(Boolean).join(" - "),
          vanData: van,
        }
      })
      setAllVans(vanOptions)
      setVans(vanOptions)
    } catch (error) {
      console.error("Failed to load data:", error)
      toast.error("Failed to load data")
    } finally {
      setLoading(false)
    }
  }

  const handleVanSelect = (selectedOption: any) => {
    setSelectedVan(selectedOption)

    setAllocationForm(prev => ({
      ...prev,
      vanId: selectedOption?.value || "",
      driverId: selectedOption?.vanData?.driver?._id || "",
    }))
  }

  const handleCreateAllocation = async () => {
    if (!allocationVehicleId) {
      toast.error("Please select Vehicle.")
      return
    }
    if (!allocationShiftId) {
      toast.error("Please select Shift.")
      return
    }
    if (!allocationRoute) {
      toast.error("Please select Route.")
      return
    }
    if (!allocationDriverId) {
      toast.error("Please select Driver.")
      return
    }
    const studentId = allocationStudentId
    if (!studentId) {
      toast.error("Please select Student.")
      return
    }
    const selectedVanOption = vans.find(v => v.value === allocationVehicleId)
    const isPrivateVan =
      (selectedVanOption?.vanData?.contractorId?.contractorType || "").toLowerCase() === "private"

    const feeAmountNum =
      !isPrivateVan && allocationFeeAmount.trim()
        ? Number(allocationFeeAmount)
        : undefined
    if (
      !isPrivateVan &&
      allocationFeeAmount.trim() &&
      (isNaN(feeAmountNum!) || feeAmountNum! < 0)
    ) {
      toast.error("Please enter a valid Fee Amount.")
      return
    }
    setIsAssigning(true)
    try {
      await createAllocation({
        studentId,
        vanId: allocationVehicleId,
        driverId: allocationDriverId,
        pickupStop: allocationRoute,
        sessionId: currentSession?._id,
        ...(!isPrivateVan &&
          feeAmountNum != null &&
          !isNaN(feeAmountNum) &&
          feeAmountNum >= 0 && { feeAmount: feeAmountNum }),
      })
      toast.success("Vehicle assigned successfully")

      if (onAllocationCreated) {
        onAllocationCreated()
      }

      setAllocationForm({
        vanId: "",
        driverId: "",
        pickupStop: "",
      })
      setAllocationVehicleId("")
      setAllocationShiftId("")
      setAllocationRoute("")
      setAllocationDriverId("")
      setShiftsForAllocationVehicle([])
      setRoutesForAllocationVehicleShift([])
      setDriversForAllocationVehicle([])
      setAllocationStudentId("")
      setAllocationFeeAmount("")
      setSelectedPickupPoint(null)
      setSelectedVan(null)
      setVans(allVans)

      const closeButton = document.querySelector(
        '#add_assign_vehicle [data-bs-dismiss="modal"]',
      ) as HTMLElement
      if (closeButton) closeButton.click()
    } catch (error: any) {
      console.error("Allocation error:", error)
      toast.error(error.response?.data?.message || "Failed to assign vehicle")
    } finally {
      setIsAssigning(false)
    }
  }

  useEffect(() => {
    if (!allocationToEdit || allVans.length === 0) return

    const loadDriversForEdit = async () => {
      try {
        const res = await getAllDrivers({ limit: 500 })
        setAllDriversWithAssignments(res?.data || [])
      } catch {
        setAllDriversWithAssignments([])
      }
    }
    loadDriversForEdit()

    const vanId = allocationToEdit.van?._id
    const driverId =
      (allocationToEdit.driver as any)?._id ||
      (allocationToEdit.driver as any)?.id ||
      ""
    const pickupStop = allocationToEdit.pickupStop?.trim() || ""
    const feeAmount = allocationToEdit.feeAmount ?? ""

    setAllocationVehicleId(vanId || "")
    setAllocationDriverId(driverId)
    setAllocationFeeAmount(String(feeAmount))
    setAllocationStudentBranch((allocationToEdit as any).branch?.name ?? "")
    setEditAllocationForm(prev => ({
      ...prev,
      status: (allocationToEdit.status as "active" | "inactive") || "active",
    }))

    const student = allocationToEdit.student
    const studentId = student?._id
    if (studentId) {
      setEditAllocationForm(prev => ({ ...prev, studentId }))
      const stu = student as any
      const label =
        stu?.first_name || stu?.last_name || stu?.grNumber
          ? `${(stu.first_name || "").trim()} ${(stu.last_name || "").trim()}`.trim()
            ? `${(stu.first_name || "").trim()} ${(stu.last_name || "").trim()} - GR: ${stu.grNumber || "N/A"}`
            : `GR: ${stu.grNumber || studentId}`
          : studentId
      setAllocationStudentId(studentId)
      setEditStudentOption({ value: studentId, label })
    } else {
      setEditStudentOption(null)
    }
  }, [allocationToEdit, allVans, selectedSystem])

  const handlePickupPointSelect = (selectedOption: any) => {
    setSelectedPickupPoint(selectedOption)

    setAllocationForm(prev => ({
      ...prev,
      pickupStop: selectedOption?.label || "",
    }))

    if (selectedOption?.label) {
      const label = selectedOption.label.trim()
      const filtered = allVans.filter(
        van =>
          Array.isArray(van.vanData?.route_name) &&
          van.vanData.route_name.some((r: any) => r?.name?.trim() === label),
      )
      setVans(filtered)
      setSelectedVan(null)
      setAllocationForm(prev => ({ ...prev, vanId: "", driverId: "" }))
    } else {
      setVans(allVans)
      setSelectedVan(null)
      setAllocationForm(prev => ({ ...prev, vanId: "", driverId: "" }))
    }
  }

  const handleEditPickupPointSelect = (selectedOption: any) => {
    setSelectedPickupPoint(selectedOption)

    setEditAllocationForm(prev => ({
      ...prev,
      pickupStop: selectedOption?.label || "",
      vanId: "",
      driverId: "",
    }))

    if (selectedOption?.label) {
      const label = selectedOption.label.trim()
      const filtered = allVans.filter(
        van =>
          Array.isArray(van.vanData?.route_name) &&
          van.vanData.route_name.some((r: any) => r?.name?.trim() === label),
      )
      setVans(filtered)
    } else {
      setVans(allVans)
    }

    setSelectedVan(null)
  }

  const handleEditAllocation = async () => {
    setIsEditing(true)
    try {
      if (!onEditAllocation || !allocationToEdit) {
        toast.error("Edit function not available")
        return
      }

      const studentId = allocationStudentId || editAllocationForm.studentId
      if (!studentId) {
        toast.error("Please select Student.")
        return
      }
      if (!allocationVehicleId) {
        toast.error("Please select Vehicle.")
        return
      }
      if (!allocationShiftId) {
        toast.error("Please select Shift.")
        return
      }
      if (!allocationRoute) {
        toast.error("Please select Route.")
        return
      }
      if (!allocationDriverId) {
        toast.error("Please select Driver.")
        return
      }

      const selectedVanOption = vans.find(v => v.value === allocationVehicleId)
      const isPrivateVan =
        (selectedVanOption?.vanData?.contractorId?.contractorType || "").toLowerCase() === "private"
      const feeAmountNum =
        !isPrivateVan &&
        allocationFeeAmount.trim() &&
        !isNaN(Number(allocationFeeAmount))
          ? Number(allocationFeeAmount)
          : undefined
      const updatedData = {
        studentId,
        vanId: allocationVehicleId,
        driverId: allocationDriverId,
        shiftId: allocationShiftId || undefined,
        route: allocationRoute ? String(allocationRoute).trim() : undefined,
        pickupStop: allocationRoute,
        status: editAllocationForm.status,
        sessionId: currentSession?._id,
        ...(feeAmountNum != null &&
          !isNaN(feeAmountNum) && { feeAmount: feeAmountNum }),
      }

      const success = await onEditAllocation(allocationToEdit._id, updatedData)

      if (success) {
        const el = document.getElementById("edit_assign_vehicle")
        if (el) {
          el.setAttribute("data-bs-dismiss", "modal")
          el.click()
          el.removeAttribute("data-bs-dismiss")
        }

        setEditAllocationForm({
          studentId: "",
          vanId: "",
          driverId: "",
          pickupStop: "",
          status: "active",
          feeAmount: "",
        })
        setAllocationVehicleId("")
        setAllocationShiftId("")
        setAllocationRoute("")
        setAllocationDriverId("")
        setShiftsForAllocationVehicle([])
        setRoutesForAllocationVehicleShift([])
        setDriversForAllocationVehicle([])
        setAllocationStudentId("")
        setAllocationFeeAmount("")
        setSelectedVan(null)

        if (onAllocationCreated) {
          onAllocationCreated()
        }

        if (setAllocationToEdit) {
          setAllocationToEdit(null)
        }
      }
    } catch (error: any) {
      console.error("Edit allocation error:", error)
      toast.error(
        error.response?.data?.message || "Failed to update allocation",
      )
    } finally {
      setIsEditing(false)
    }
  }

  const handleEditVanSelect = (selectedOption: any) => {
    const vanId = selectedOption?.value || ""
    const selectedVanData = selectedOption?.vanData

    setSelectedVan(selectedOption)

    setEditAllocationForm(prev => ({
      ...prev,
      vanId: vanId,
      driverId:
        selectedVanData?.driver?._id || selectedVanData?.driver_id || "",
    }))
  }

  return (
    <>
      <>
        {/* <div className="modal fade" id="add_routes">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Add Route</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">Route Name</label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                    <div className="modal-satus-toggle d-flex align-items-center justify-content-between">
                      <div className="status-title">
                        <h5>Status</h5>
                        <p>Change the Status by toggle </p>
                      </div>
                      <div className="status-toggle modal-status">
                        <input type="checkbox" id="user1" className="check" />
                        <label htmlFor="user1" className="checktoggle">
                          {" "}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <Link
                    to="#"
                    data-bs-dismiss="modal"
                    className="btn btn-primary"
                  >
                    Add Route
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div> */}
        {/* Add Route*/}
        {/* Edit Route */}
        {/* <div className="modal fade" id="edit_routes">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Edit Route</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">Route Name</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Route Name"
                          defaultValue="Seattle"
                        />
                      </div>
                    </div>
                    <div className="modal-satus-toggle d-flex align-items-center justify-content-between">
                      <div className="status-title">
                        <h5>Status</h5>
                        <p>Change the Status by toggle </p>
                      </div>
                      <div className="status-toggle modal-status">
                        <input
                          type="checkbox"
                          id="user2"
                          className="check"
                          defaultChecked
                        />
                        <label htmlFor="user2" className="checktoggle">
                          {" "}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <Link
                    to="#"
                    data-bs-dismiss="modal"
                    className="btn btn-primary"
                  >
                    Save Changes
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div> */}
        {/* Edit Route */}
      </>
      <>
        {/* Add Assign New Vehicle */}
        <div className="modal fade" id="add_assign_vehicle">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Assign New Vehicle</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form
                onSubmit={e => {
                  e.preventDefault()
                  handleCreateAllocation()
                }}
              >
                <div className="modal-body">
                  <h5 className="text-dark fw-semibold mb-3">
                    ADD STUDENT TRANSPORT REGISTRATION
                  </h5>
                  <div className="row">
                    <div className="col-md-12 mb-3">
                      <label className="form-label">
                        Select Student (GR){" "}
                        <span className="text-danger">*</span>
                      </label>
                      <TransportStudentDropdown
                        selectedSystem={selectedSystem}
                        value={allocationStudentId}
                        onChange={setAllocationStudentId}
                        onSelectStudent={stu => {
                          if (stu) {
                            setAllocationStudentBranch(
                              stu.branch?.name ?? ""
                            )
                            setAllocationStudentSystem(
                              stu.system?._id ?? stu.system ?? ""
                            )
                          } else {
                            setAllocationStudentBranch("")
                            setAllocationStudentSystem("")
                          }
                        }}
                        placeholder="Select Student"
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">
                        Select Vehicle <span className="text-danger">*</span>
                      </label>
                      <CommonSelect
                        className="select"
                        options={vans}
                        value={
                          vans.find(v => v.value === allocationVehicleId) ||
                          null
                        }
                        onChange={opt =>
                          setAllocationVehicleId(opt?.value ?? "")
                        }
                        placeholder={
                          loading ? "Loading vehicles..." : "Select Vehicle"
                        }
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">
                        Select Shift <span className="text-danger">*</span>
                      </label>
                      <CommonSelect
                        className="select"
                        options={shiftsForAllocationVehicle}
                        value={
                          shiftsForAllocationVehicle.find(
                            s => s.value === allocationShiftId,
                          ) || null
                        }
                        onChange={opt => setAllocationShiftId(opt?.value ?? "")}
                        placeholder={
                          loadingAllocationShifts
                            ? "Loading..."
                            : "Select Shift"
                        }
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">
                        Select Route <span className="text-danger">*</span>
                      </label>
                      <CommonSelect
                        className="select"
                        options={routesForAllocationVehicleShift}
                        value={
                          routesForAllocationVehicleShift.find(
                            r => r.value === allocationRoute,
                          ) || null
                        }
                        onChange={opt => setAllocationRoute(opt?.value ?? "")}
                        placeholder={
                          loadingAllocationRoutes
                            ? "Loading..."
                            : "Select Route"
                        }
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">
                        Driver{" "}
                        {allocationRoute && driversForAllocationVehicle.length === 1 && (
                          <span className="badge bg-secondary ms-1" style={{ fontSize: "0.7rem" }}>Auto</span>
                        )}
                      </label>
                      <CommonSelect
                        className="select"
                        options={driversForAllocationVehicle}
                        value={
                          driversForAllocationVehicle.find(
                            d => d.value === allocationDriverId,
                          ) || null
                        }
                        onChange={opt =>
                          setAllocationDriverId(opt?.value ?? "")
                        }
                        placeholder={allocationRoute ? "No driver assigned to this route" : "Select Driver"}
                        isDisabled={!!(allocationRoute && driversForAllocationVehicle.length === 1)}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Campus</label>
                      <input
                        type="text"
                        className="form-control"
                        value={allocationStudentBranch || "Auto-filled on student select"}
                        readOnly
                        disabled
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">System</label>
                      <input
                        type="text"
                        className="form-control"
                        value={selectedSystem?.name || allocationStudentSystem || ""}
                        readOnly
                        disabled
                      />
                    </div>
                    {(() => {
                      const selectedVanOption = vans.find(
                        v => v.value === allocationVehicleId,
                      )
                      const isPrivateVan =
                        (selectedVanOption?.vanData?.contractorId?.contractorType || "").toLowerCase() === "private"
                      if (isPrivateVan) return null
                      return (
                        <div className="col-md-6 mb-3">
                          <label className="form-label">Fee Amount</label>
                          <input
                            type="number"
                            className="form-control"
                            placeholder="Enter fee amount"
                            min={0}
                            step={0.01}
                            value={allocationFeeAmount}
                            onChange={e =>
                              setAllocationFeeAmount(e.target.value)
                            }
                          />
                        </div>
                      )
                    })()}
                  </div>
                </div>
                <div className="modal-footer">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <button type="submit" className="btn btn-primary" disabled={isAssigning}>
                    {isAssigning ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                        Assigning...
                      </>
                    ) : (
                      "Assign Now"
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* Edit Assign New Vehicle */}
        <div className="modal fade" id="edit_assign_vehicle">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Edit Assign Vehicle</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form
                onSubmit={e => {
                  e.preventDefault()
                  handleEditAllocation()
                }}
              >
                <div className="modal-body">
                  <h5 className="text-dark fw-semibold mb-3">
                    EDIT STUDENT TRANSPORT REGISTRATION
                  </h5>
                  <div className="row">
                    <div className="col-md-12 mb-3">
                      <label className="form-label">
                        Select Student (GR){" "}
                        <span className="text-danger">*</span>
                      </label>
                      <TransportStudentDropdown
                        selectedSystem={selectedSystem}
                        value={allocationStudentId}
                        onChange={setAllocationStudentId}
                        onSelectStudent={stu => {
                          if (stu) {
                            setAllocationStudentBranch(stu.branch?.name ?? "")
                            setAllocationStudentSystem(
                              stu.system?._id ?? stu.system ?? ""
                            )
                          } else {
                            setAllocationStudentBranch("")
                            setAllocationStudentSystem("")
                          }
                        }}
                        placeholder="Select Student"
                        optionForCurrentValue={editStudentOption}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">
                        Select Vehicle <span className="text-danger">*</span>
                      </label>
                      <CommonSelect
                        className="select"
                        options={vans}
                        value={
                          vans.find(v => v.value === allocationVehicleId) ||
                          null
                        }
                        onChange={opt => {
                          setAllocationVehicleId(opt?.value ?? "")
                        }}
                        placeholder={
                          loading ? "Loading vehicles..." : "Select Vehicle"
                        }
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">
                        Select Shift <span className="text-danger">*</span>
                      </label>
                      <CommonSelect
                        className="select"
                        options={shiftsForAllocationVehicle}
                        value={
                          shiftsForAllocationVehicle.find(
                            s => s.value === allocationShiftId,
                          ) || null
                        }
                        onChange={opt => setAllocationShiftId(opt?.value ?? "")}
                        placeholder={
                          loadingAllocationShifts
                            ? "Loading..."
                            : "Select Shift"
                        }
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">
                        Select Route <span className="text-danger">*</span>
                      </label>
                      <CommonSelect
                        className="select"
                        options={routesForAllocationVehicleShift}
                        value={
                          routesForAllocationVehicleShift.find(
                            r => r.value === allocationRoute,
                          ) || null
                        }
                        onChange={opt => setAllocationRoute(opt?.value ?? "")}
                        placeholder={
                          loadingAllocationRoutes
                            ? "Loading..."
                            : "Select Route"
                        }
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">
                        Driver{" "}
                        {allocationRoute && driversForAllocationVehicle.length === 1 && (
                          <span className="badge bg-secondary ms-1" style={{ fontSize: "0.7rem" }}>Auto</span>
                        )}
                      </label>
                      <CommonSelect
                        className="select"
                        options={driversForAllocationVehicle}
                        value={
                          driversForAllocationVehicle.find(
                            d => d.value === allocationDriverId,
                          ) || null
                        }
                        onChange={opt =>
                          setAllocationDriverId(opt?.value ?? "")
                        }
                        placeholder={allocationRoute ? "No driver assigned to this route" : "Select Driver"}
                        isDisabled={!!(allocationRoute && driversForAllocationVehicle.length === 1)}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Campus</label>
                      <input
                        type="text"
                        className="form-control"
                        value={allocationStudentBranch || "Auto-filled on student select"}
                        readOnly
                        disabled
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">System</label>
                      <input
                        type="text"
                        className="form-control"
                        value={selectedSystem?.name || allocationStudentSystem || ""}
                        readOnly
                        disabled
                      />
                    </div>
                    {(() => {
                      const selectedVanOption = vans.find(
                        v => v.value === allocationVehicleId,
                      )
                      const isPrivateVan =
                        (selectedVanOption?.vanData?.contractorId?.contractorType || "").toLowerCase() === "private"
                      if (isPrivateVan) return null
                      return (
                        <div className="col-md-6 mb-3">
                          <label className="form-label">Fee Amount</label>
                          <input
                            type="number"
                            className="form-control"
                            placeholder="Enter fee amount"
                            min={0}
                            step={0.01}
                            value={allocationFeeAmount}
                            onChange={e =>
                              setAllocationFeeAmount(e.target.value)
                            }
                          />
                        </div>
                      )
                    })()}
                    <div className="col-md-12">
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="status-title">
                          <h5>Status</h5>
                          <p>Change the Status by toggle</p>
                        </div>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="edit_driver_status"
                            checked={editAllocationForm.status === "active"}
                            onChange={e => {
                              setEditAllocationForm(prev => ({
                                ...prev,
                                status: e.target.checked
                                  ? "active"
                                  : "inactive",
                              }))
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <button type="submit" className="btn btn-primary" disabled={isEditing}>
                    {isEditing ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                        Saving...
                      </>
                    ) : (
                      "Save Changes"
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* Edit Assign New Vehicle */}
      </>
      <>
        {/* Add Pickup */}
        <div className="modal fade" id="add_pickup">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Add Pickup Point</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">Pickup Point</label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                    <div className="modal-satus-toggle d-flex align-items-center justify-content-between">
                      <div className="status-title">
                        <h5>Status</h5>
                        <p>Change the Status by toggle </p>
                      </div>
                      <div className="status-toggle modal-status">
                        <input type="checkbox" id="user1" className="check" />
                        <label htmlFor="user1" className="checktoggle">
                          {" "}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <Link
                    to="#"
                    data-bs-dismiss="modal"
                    className="btn btn-primary"
                  >
                    Add Pickup Point
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* Add Pickup */}
        {/* Edit Pickup */}
        {/* <div className="modal fade" id="edit_pickup">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Edit Pickup Point</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">Pickup Point</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Pickup Point"
                          defaultValue="2603 Wood Duck Drive Marquette, MI"
                        />
                      </div>
                    </div>
                    <div className="modal-satus-toggle d-flex align-items-center justify-content-between">
                      <div className="status-title">
                        <h5>Status</h5>
                        <p>Change the Status by toggle </p>
                      </div>
                      <div className="status-toggle modal-status">
                        <input
                          type="checkbox"
                          id="user2"
                          className="check"
                          defaultChecked
                        />
                        <label htmlFor="user2" className="checktoggle">
                          {" "}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <Link
                    to="#"
                    data-bs-dismiss="modal"
                    className="btn btn-primary"
                  >
                    Save Changes
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div> */}
        {/* Edit Pickup */}
      </>
      <>
        {/* Add Driver */}
        <div className="modal fade" id="add_driver">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Add New Driver</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">First Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="first_name"
                          value={driverForm.first_name}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Last Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="last_name"
                          value={driverForm.last_name}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Phone Number</label>
                        <input
                          type="text"
                          className="form-control"
                          name="contact_number"
                          value={driverForm.contact_number}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">CNIC</label>
                        <input
                          type="text"
                          className="form-control"
                          name="cnic"
                          placeholder="XXXXX-XXXXXXX-X"
                          value={driverForm.cnic}
                          onChange={e => {
                            const digits = e.target.value.replace(/\D/g, "").slice(0, 13)
                            let formatted = digits
                            if (digits.length > 12) formatted = `${digits.slice(0, 5)}-${digits.slice(5, 12)}-${digits.slice(12)}`
                            else if (digits.length > 5) formatted = `${digits.slice(0, 5)}-${digits.slice(5)}`
                            setDriverForm((prev: any) => ({ ...prev, cnic: formatted }))
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">Driving License Number</label>
                        <input
                          type="text"
                          className="form-control"
                          name="license_number"
                          value={driverForm.license_number}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Driving License (image)</label>
                        <input
                          type="file"
                          className="form-control"
                          accept="image/*,.pdf"
                          onChange={e => {
                            const f = e.target.files?.[0]
                            setDriverDocFiles(prev => ({
                              ...prev,
                              drivingLicense: f ?? null,
                            }))
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">CNIC (image)</label>
                        <input
                          type="file"
                          className="form-control"
                          accept="image/*,.pdf"
                          onChange={e => {
                            const f = e.target.files?.[0]
                            setDriverDocFiles(prev => ({
                              ...prev,
                              cnic: f ?? null,
                            }))
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Address</label>
                        <input
                          type="text"
                          className="form-control"
                          name="address"
                          value={driverForm.address}
                          onChange={handleInputChange}
                          placeholder="Enter Address"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Joining Date</label>
                        <input
                          type="date"
                          className="form-control"
                          name="joining_date"
                          value={driverForm.joining_date}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <h6 className="text-dark fw-semibold mb-2">
                        Driver Assignments
                      </h6>
                      {assignmentRows.map((row, index) => {
                        // Same vehicle allowed in multiple rows — only block the same vehicle+shift pair
                        const usedShiftIdsForVehicle = assignmentRows
                          .filter((r, i) => i !== index && r.vehicleId === row.vehicleId && r.shiftId)
                          .map(r => r.shiftId)
                        const availableShifts = (shiftsCache[row.vehicleId] ?? []).filter(
                          s => !usedShiftIdsForVehicle.includes(s.value),
                        )
                        return (
                          <div
                            key={index}
                            className="border rounded p-2 mb-2 position-relative"
                            style={{ background: "#fafafa" }}
                          >
                            {assignmentRows.length > 1 && (
                              <button
                                type="button"
                                className="btn btn-sm text-danger position-absolute p-0 lh-1"
                                style={{ top: 6, right: 8, background: "none", border: "none" }}
                                onClick={() => handleRemoveAssignment(index)}
                                title="Remove"
                              >
                                <i className="ti ti-x fs-6" />
                              </button>
                            )}
                            <div className="row g-2 mb-2">
                              <div className="col-6">
                                <label className="form-label small mb-1">
                                  Vehicle
                                </label>
                                <CommonSelect
                                  className="select"
                                  options={driverVehicles}
                                  value={driverVehicles.find(v => v.value === row.vehicleId) || null}
                                  onChange={opt =>
                                    handleAssignmentVehicleChange(
                                      index,
                                      opt?.value ?? "",
                                    )
                                  }
                                  placeholder={
                                    loadingDriverVehicles
                                      ? "Loading..."
                                      : "Select vehicle"
                                  }
                                />
                              </div>
                              <div className="col-6">
                                <label className="form-label small mb-1">
                                  Shift
                                </label>
                                <CommonSelect
                                  className="select"
                                  options={availableShifts}
                                  value={availableShifts.find(s => s.value === row.shiftId) || null}
                                  onChange={opt =>
                                    handleAssignmentShiftChange(
                                      index,
                                      opt?.value ?? "",
                                    )
                                  }
                                  placeholder={
                                    loadingShiftsForVehicleId === row.vehicleId
                                      ? "Loading shifts..."
                                      : row.vehicleId
                                        ? "Select shift"
                                        : "Select vehicle first"
                                  }
                                />
                              </div>
                            </div>
                            <div>
                              <label className="form-label small mb-1">
                                Routes
                              </label>
                              {loadingRoutesForKey ===
                              `${row.vehicleId}-${row.shiftId}` ? (
                                <div className="text-muted small fst-italic">
                                  Loading routes...
                                </div>
                              ) : row.routes.length > 0 ? (
                                <div className="d-flex flex-wrap gap-1">
                                  {row.routes.map(r => (
                                    <span
                                      key={r}
                                      className="badge rounded-pill text-dark border"
                                      style={{ background: "#e8f4fd", fontSize: "0.78rem", fontWeight: 500 }}
                                    >
                                      <i className="ti ti-map-pin me-1" style={{ fontSize: "0.7rem" }} />
                                      {r}
                                    </span>
                                  ))}
                                </div>
                              ) : (
                                <div className="text-muted small fst-italic">
                                  {row.shiftId
                                    ? "No routes configured for this shift"
                                    : "Select a shift to see routes"}
                                </div>
                              )}
                            </div>
                          </div>
                        )
                      })}
                      <button
                        type="button"
                        className="btn btn-outline-primary btn-sm w-100 mt-1"
                        onClick={handleAddAssignmentRow}
                      >
                        <i className="ti ti-plus me-1" />
                        Add Another Assignment
                      </button>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <Link
                    to="#"
                    className={`btn btn-primary${driverAddSubmitting ? " disabled" : ""}`}
                    onClick={driverAddSubmitting ? undefined : handleSubmit}
                    aria-disabled={driverAddSubmitting}
                  >
                    {driverAddSubmitting && (
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                    )}
                    {driverAddSubmitting ? "Saving..." : "Add Driver"}
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* Add Driver */}
      </>
      {/* Edit Driver */}
      <>
        <div className="modal fade" id="edit_driver">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Edit Driver</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => setDriverToEdit && setDriverToEdit(null)}
                >
                  <i className="ti ti-x" />
                </button>
              </div>

              <form>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">First Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="first_name"
                          placeholder="Enter First Name"
                          value={editDriverForm.first_name}
                          onChange={handleEditInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Last Name</label>
                        <input
                          type="text"
                          className="form-control"
                          name="last_name"
                          placeholder="Enter Last Name"
                          value={editDriverForm.last_name}
                          onChange={handleEditInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Phone Number</label>
                        <input
                          type="text"
                          className="form-control"
                          name="contact_number"
                          placeholder="Enter Phone Number"
                          value={editDriverForm.contact_number}
                          onChange={handleEditInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">CNIC</label>
                        <input
                          type="text"
                          className="form-control"
                          name="cnic"
                          placeholder="XXXXX-XXXXXXX-X"
                          value={editDriverForm.cnic ?? ""}
                          onChange={e => {
                            const digits = e.target.value.replace(/\D/g, "").slice(0, 13)
                            let formatted = digits
                            if (digits.length > 12) formatted = `${digits.slice(0, 5)}-${digits.slice(5, 12)}-${digits.slice(12)}`
                            else if (digits.length > 5) formatted = `${digits.slice(0, 5)}-${digits.slice(5)}`
                            setEditDriverForm((prev: any) => ({ ...prev, cnic: formatted }))
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">Driving License Number</label>
                        <input
                          type="text"
                          className="form-control"
                          name="license_number"
                          placeholder="Enter Driving License Number"
                          value={editDriverForm.license_number}
                          onChange={handleEditInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Driving License (image)</label>
                        <input
                          type="file"
                          className="form-control"
                          accept="image/*,.pdf"
                          onChange={e => {
                            const f = e.target.files?.[0]
                            setDriverDocFiles(prev => ({
                              ...prev,
                              drivingLicense: f ?? null,
                            }))
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">CNIC (image)</label>
                        <input
                          type="file"
                          className="form-control"
                          accept="image/*,.pdf"
                          onChange={e => {
                            const f = e.target.files?.[0]
                            setDriverDocFiles(prev => ({
                              ...prev,
                              cnic: f ?? null,
                            }))
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Address</label>
                        <input
                          type="text"
                          className="form-control"
                          name="address"
                          placeholder="Enter Address"
                          value={editDriverForm.address}
                          onChange={handleEditInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Joining Date</label>
                        <input
                          type="date"
                          className="form-control"
                          name="joining_date"
                          value={editDriverForm.joining_date}
                          onChange={handleEditInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <h6 className="text-dark fw-semibold mb-2">
                        Driver Assignments
                      </h6>
                      {editAssignmentRows.map((row, index) => {
                        // Same vehicle allowed in multiple rows — only block the same vehicle+shift pair
                        const usedShiftIdsForVehicle = editAssignmentRows
                          .filter((r, i) => i !== index && r.vehicleId === row.vehicleId && r.shiftId)
                          .map(r => r.shiftId)
                        const availableShifts = (editShiftsCache[row.vehicleId] ?? []).filter(
                          s => !usedShiftIdsForVehicle.includes(s.value),
                        )
                        return (
                          <div
                            key={index}
                            className="border rounded p-2 mb-2 position-relative"
                            style={{ background: "#fafafa" }}
                          >
                            {editAssignmentRows.length > 1 && (
                              <button
                                type="button"
                                className="btn btn-sm text-danger position-absolute p-0 lh-1"
                                style={{ top: 6, right: 8, background: "none", border: "none" }}
                                onClick={() => handleRemoveEditAssignment(index)}
                                title="Remove"
                              >
                                <i className="ti ti-x fs-6" />
                              </button>
                            )}
                            <div className="row g-2 mb-2">
                              <div className="col-6">
                                <label className="form-label small mb-1">
                                  Vehicle
                                </label>
                                <CommonSelect
                                  className="select"
                                  options={driverVehicles}
                                  value={driverVehicles.find(v => v.value === row.vehicleId) || null}
                                  onChange={opt =>
                                    handleEditAssignmentVehicleChange(
                                      index,
                                      opt?.value ?? "",
                                    )
                                  }
                                  placeholder={
                                    loadingDriverVehicles
                                      ? "Loading..."
                                      : "Select vehicle"
                                  }
                                />
                              </div>
                              <div className="col-6">
                                <label className="form-label small mb-1">
                                  Shift
                                </label>
                                <CommonSelect
                                  className="select"
                                  options={availableShifts}
                                  value={availableShifts.find(s => s.value === row.shiftId) || null}
                                  onChange={opt =>
                                    handleEditAssignmentShiftChange(
                                      index,
                                      opt?.value ?? "",
                                    )
                                  }
                                  placeholder={
                                    loadingEditShiftsForVehicleId ===
                                    row.vehicleId
                                      ? "Loading shifts..."
                                      : row.vehicleId
                                        ? "Select shift"
                                        : "Select vehicle first"
                                  }
                                />
                              </div>
                            </div>
                            <div>
                              <label className="form-label small mb-1">
                                Routes
                              </label>
                              {loadingEditRoutesForKey ===
                              `${row.vehicleId}-${row.shiftId}` ? (
                                <div className="text-muted small fst-italic">
                                  Loading routes...
                                </div>
                              ) : row.routes.length > 0 ? (
                                <div className="d-flex flex-wrap gap-1">
                                  {row.routes.map(r => (
                                    <span
                                      key={r}
                                      className="badge rounded-pill text-dark border"
                                      style={{ background: "#e8f4fd", fontSize: "0.78rem", fontWeight: 500 }}
                                    >
                                      <i className="ti ti-map-pin me-1" style={{ fontSize: "0.7rem" }} />
                                      {r}
                                    </span>
                                  ))}
                                </div>
                              ) : (
                                <div className="text-muted small fst-italic">
                                  {row.shiftId
                                    ? "No routes configured for this shift"
                                    : "Select a shift to see routes"}
                                </div>
                              )}
                            </div>
                          </div>
                        )
                      })}
                      <button
                        type="button"
                        className="btn btn-outline-primary btn-sm w-100 mt-1"
                        onClick={handleAddEditAssignmentRow}
                      >
                        <i className="ti ti-plus me-1" />
                        Add Another Assignment
                      </button>
                    </div>
                    <div className="col-md-12">
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="status-title">
                          <h5>Status</h5>
                          <p>Change the Status by toggle</p>
                        </div>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="edit_driver_status"
                            checked={editDriverForm.status === "active"}
                            onChange={e => {
                              setEditDriverForm(prev => ({
                                ...prev,
                                status: e.target.checked
                                  ? "active"
                                  : "inactive",
                              }))
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="modal-footer">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                    onClick={() => setDriverToEdit && setDriverToEdit(null)}
                  >
                    Cancel
                  </Link>
                  <Link
                    to="#"
                    className="btn btn-primary"
                    data-bs-dismiss="modal"
                    onClick={handleEditSubmit}
                  >
                    Save Changes
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </>
      {/*Edit Drive */}

      <>
        {/* Add New Vehicle */}
        <div className="modal fade" id="add_vehicle">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Add New Vehicle</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form
                onSubmit={e => {
                  e.preventDefault()
                  handleVanSubmit()
                }}
              >
                <div className="modal-body">
                  <h5 className="text-dark fw-semibold mb-3">VEHICLE</h5>
                  <div className="row">
                    <div className="col-12 mb-3">
                      <label className="form-label">Contractor Name</label>
                      <CommonSelect
                        className="select"
                        options={contractors}
                        value={
                          contractors.find(
                            c => c.value === vanForm.contractor,
                          ) || null
                        }
                        onChange={opt => {
                          const contractorId = opt?.value ?? ""
                          setVanForm(prev => ({
                            ...prev,
                            contractor: contractorId,
                          }))
                          // Clear selected routes when contractor changes so user only picks from that contractor's areas
                          setShiftRoutePairs(prev =>
                            prev.map(p => ({ ...p, routes: [] })),
                          )
                        }}
                        placeholder={
                          loadingContractors ? "Loading..." : "Select"
                        }
                      />
                    </div>
                    {shiftRoutePairs.map((pair, index) => (
                      <div key={index} className="col-12 mb-3">
                        <div className="row g-2 align-items-end">
                          <div className="col-md-3">
                            <label className="form-label small">
                              Select Shift
                            </label>
                            <CommonSelect
                              className="select"
                              options={transportShifts}
                              value={
                                transportShifts.find(
                                  s => s.value === pair.shiftId,
                                ) || null
                              }
                              onChange={opt =>
                                handleShiftRoutePairChange(index, "shift", opt)
                              }
                              placeholder={
                                loadingShifts ? "Loading..." : "Select"
                              }
                            />
                          </div>
                          <div className="col-md-6">
                            <label className="form-label small">
                              Select Route(s)
                            </label>
                            <MultiSelectSection
                              options={routeOptionsForAddVan}
                              value={pair.routes || []}
                              onChange={val =>
                                handleShiftRoutePairChange(index, "route", val)
                              }
                              placeholder={
                                vanForm.contractor
                                  ? "Select routes"
                                  : "Select contractor first"
                              }
                              isDisabled={!vanForm.contractor}
                            />
                          </div>
                          <div className="col-md-3 d-flex gap-1">
                            <button
                              type="button"
                              className="btn btn-primary btn-sm px-2"
                              onClick={addShiftRouteRow}
                              title="Add row"
                            >
                              <i className="ti ti-plus" />
                            </button>
                            {shiftRoutePairs.length > 1 && (
                              <button
                                type="button"
                                className="btn btn-danger btn-sm px-2"
                                onClick={() => removeShiftRouteRow(index)}
                                title="Remove row"
                              >
                                <i className="ti ti-minus" />
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Vehicle Number</label>
                      <input
                        type="text"
                        className="form-control"
                        name="registration_number"
                        value={vanForm.registration_number}
                        onChange={handleVanInputChange}
                        placeholder="Enter Vehicle Number"
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Maker</label>
                      <input
                        type="text"
                        className="form-control"
                        name="model"
                        value={vanForm.model}
                        onChange={handleVanInputChange}
                        placeholder="Enter Maker"
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Chassis Number</label>
                      <input
                        type="text"
                        className="form-control"
                        name="chassis_number"
                        value={vanForm.chassis_number}
                        onChange={handleVanInputChange}
                        placeholder="Enter Chassis Number"
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Engine Number</label>
                      <input
                        type="text"
                        className="form-control"
                        name="engine_number"
                        value={vanForm.engine_number}
                        onChange={handleVanInputChange}
                        placeholder="Enter Engine Number"
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">
                        Vehicle Registration (Image) <span className="text-danger">*</span>
                      </label>
                      <input
                        type="file"
                        className="form-control"
                        accept="image/*,.pdf"
                        required
                        onChange={e => {
                          const f = e.target.files?.[0]
                          setVanDocFiles(prev => ({
                            ...prev,
                            carRegistration: f ?? null,
                          }))
                        }}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Capacity</label>
                      <input
                        type="number"
                        min={0}
                        className="form-control"
                        name="capacity"
                        value={vanForm.capacity}
                        onChange={handleVanInputChange}
                        onFocus={e => e.target.select()}
                        placeholder="Enter Capacity"
                      />
                    </div>
                    <div className="col-12">
                      <div className="d-flex align-items-center justify-content-between">
                        <div>
                          <span className="form-label d-block mb-0">
                            Status
                          </span>
                          <p className="text-muted small mb-0 mt-0">
                            Change the Status by toggle
                          </p>
                        </div>
                        <div className="form-check form-switch mb-0">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="add_van_status"
                            checked={vanForm.status === "active"}
                            onChange={e =>
                              setVanForm(prev => ({
                                ...prev,
                                status: e.target.checked
                                  ? "active"
                                  : "inactive",
                              }))
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button
                    id="add_van"
                    type="submit"
                    className="btn btn-primary"
                    disabled={vanAddSubmitting}
                  >
                    {vanAddSubmitting && (
                      <span className="spinner-border spinner-border-sm me-2" />
                    )}
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* Add New Vehicle */}
        {/* Edit New Vehicle */}
        <div className="modal fade" id="edit_vehicle">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header align-items-center">
                <div className="d-flex align-items-center">
                  <h4 className="modal-title">Edit Vehicle</h4>
                  <span className="badge badge-soft-primary ms-2"></span>
                </div>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={handleCloseModal}
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form onSubmit={handleEditVanSubmit}>
                <div className="modal-body" id="modal-datepicker2">
                  <h5 className="text-dark fw-semibold mb-3">VEHICLE</h5>
                  <div className="row">
                    <div className="col-12 mb-3">
                      <label className="form-label">Contractor Name</label>
                      <CommonSelect
                        className="select"
                        options={contractors}
                        value={
                          contractors.find(
                            c => c.value === editVanForm.contractor,
                          ) || null
                        }
                        onChange={opt => {
                          setEditVanForm(prev => ({
                            ...prev,
                            contractor: opt?.value ?? "",
                          }))
                          setEditShiftRoutePairs(prev =>
                            prev.map(p => ({
                              ...p,
                              routeValue: "",
                              routeLabel: "",
                            })),
                          )
                        }}
                        placeholder={
                          loadingContractors ? "Loading..." : "Select"
                        }
                      />
                    </div>
                    {editShiftRoutePairs.map((pair, index) => (
                      <div key={index} className="col-12 mb-3">
                        <div className="row g-2 align-items-end">
                          <div className="col-md-4">
                            <label className="form-label small">
                              Select Shift
                            </label>
                            <CommonSelect
                              className="select"
                              options={transportShifts}
                              value={
                                transportShifts.find(
                                  s => s.value === pair.shiftId,
                                ) || null
                              }
                              onChange={opt =>
                                handleEditShiftRoutePairChange(
                                  index,
                                  "shift",
                                  opt,
                                )
                              }
                              placeholder={
                                loadingShifts ? "Loading..." : "Select"
                              }
                            />
                          </div>
                          <div className="col-md-4">
                            <label className="form-label small">
                              Select Route
                            </label>
                            <CommonSelect
                              className="select"
                              options={routeOptionsForEditVan}
                              value={
                                routeOptionsForEditVan.find(
                                  r => r.value === pair.routeValue,
                                ) || null
                              }
                              onChange={opt =>
                                handleEditShiftRoutePairChange(
                                  index,
                                  "route",
                                  opt,
                                )
                              }
                              placeholder={
                                editVanForm.contractor
                                  ? "Select"
                                  : "Select contractor first"
                              }
                              isDisabled={!editVanForm.contractor}
                            />
                          </div>
                          <div className="col-md-4 d-flex gap-1">
                            <button
                              type="button"
                              className="btn btn-primary btn-sm px-2"
                              onClick={addEditShiftRouteRow}
                              title="Add row"
                            >
                              <i className="ti ti-plus" />
                            </button>
                            {editShiftRoutePairs.length > 1 && (
                              <button
                                type="button"
                                className="btn btn-danger btn-sm px-2"
                                onClick={() => removeEditShiftRouteRow(index)}
                                title="Remove row"
                              >
                                <i className="ti ti-minus" />
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Vehicle Number</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Vehicle Number"
                        name="registration_number"
                        value={editVanForm.registration_number}
                        onChange={handleEditVanInputChange}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Maker</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Maker"
                        name="model"
                        value={editVanForm.model}
                        onChange={handleEditVanInputChange}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Chassis Number</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Chassis Number"
                        name="chassis_number"
                        value={editVanForm.chassis_number}
                        onChange={handleEditVanInputChange}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Engine Number</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Engine Number"
                        name="engine_number"
                        value={editVanForm.engine_number}
                        onChange={handleEditVanInputChange}
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">
                        Vehicle Registration (Image)
                      </label>
                      {existingRegImageUrl && !vanDocFiles.carRegistration ? (
                        <div className="d-flex align-items-center gap-2 border rounded p-2">
                          <i className="ti ti-file-description fs-5 text-primary" />
                          <a
                            href={existingRegImageUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-truncate small flex-grow-1"
                            style={{ maxWidth: 160 }}
                          >
                            View document
                          </a>
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-secondary py-0 px-1"
                            title="Replace document"
                            onClick={() => setExistingRegImageUrl(null)}
                          >
                            <i className="ti ti-replace fs-6" />
                          </button>
                        </div>
                      ) : (
                        <input
                          type="file"
                          className="form-control"
                          accept="image/*,.pdf"
                          onChange={e => {
                            const f = e.target.files?.[0]
                            setVanDocFiles(prev => ({
                              ...prev,
                              carRegistration: f ?? null,
                            }))
                          }}
                        />
                      )}
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Capacity</label>
                      <input
                        type="number"
                        min={0}
                        className="form-control"
                        placeholder="Enter Capacity"
                        name="capacity"
                        value={editVanForm.capacity}
                        onChange={handleEditVanInputChange}
                      />
                    </div>
                    <div className="col-12">
                      <div className="d-flex align-items-center justify-content-between">
                        <div>
                          <span className="form-label d-block mb-0">
                            Status
                          </span>
                          <p className="text-muted small mb-0 mt-0">
                            Change the Status by toggle
                          </p>
                        </div>
                        <div className="form-check form-switch mb-0">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="edit_van_status"
                            checked={editVanForm.status === "active"}
                            onChange={e =>
                              setEditVanForm(prev => ({
                                ...prev,
                                status: e.target.checked
                                  ? "active"
                                  : "inactive",
                              }))
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                    onClick={handleCloseModal}
                  >
                    Cancel
                  </Link>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={vanEditSubmitting}
                  >
                    {vanEditSubmitting && (
                      <span className="spinner-border spinner-border-sm me-2" />
                    )}
                    Save Changes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* Edit New Vehicle */}

        {/* Live Track */}
        {/* <div className="modal fade" id="live_track">
          <div className="modal-dialog modal-dialog-centered  modal-xl">
            <div className="modal-content">
              <div className="modal-header align-items-center">
                <div className="d-flex align-items-center">
                  <h4 className="modal-title">Live Tracking Vehicle</h4>
                  <span className="badge badge-soft-primary ms-2">
                    GPS Tracking ID : GPS7899456689
                  </span>
                </div>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <div className="modal-body mb-4">
                <ul className="book-taker-info live-track-info justify-content-between">
                  <li>
                    <span>Vehicle No</span>
                    <h6>8930</h6>
                  </li>
                  <li>
                    <span>Vehicle Model</span>
                    <h6>Scania</h6>
                  </li>
                  <li>
                    <span>Driver</span>
                    <h6>Thomas</h6>
                  </li>
                  <li>
                    <span>Driver Contact No</span>
                    <h6>+1 45644 54784</h6>
                  </li>
                </ul>
                <div className="live-track-map w-100">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3321.6088932774796!2d-117.8132203247921!3d33.64138153931407!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80dcddf599c1986f%3A0x6826f6868b4f8e35!2sHillcrest%2C%20Irvine%2C%20CA%2092603%2C%20USA!5e0!3m2!1sen!2sin!4v1706772657955!5m2!1sen!2sin"
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  />
                </div>
              </div>
              <div className="modal-footer">
                <Link
                  to="#"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </Link>
                <Link
                  to="#"
                  data-bs-dismiss="modal"
                  className="btn btn-primary"
                >
                  Reset to Live Location
                </Link>
              </div>
            </div>
          </div>
        </div> */}
        {/* Live Track */}
      </>

      {/* Delete Modal */}
      <div className="modal fade" id="delete-modal">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <form>
              <div className="modal-body text-center">
                <span className="delete-icon">
                  <i className="ti ti-trash-x" />
                </span>
                <h4>Confirm Deletion</h4>
                <p>
                  Are you sure you want to delete this driver? This action
                  cannot be undone.
                </p>
                <div className="d-flex justify-content-center">
                  <Link
                    to="#"
                    className="btn btn-light me-3"
                    onClick={() => {
                      setDriverToDelete && setDriverToDelete(null)
                      setVanToDelete && setVanToDelete(null)
                      setAllocationToDelete && setAllocationToDelete(null)
                    }}
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <Link
                    to="#"
                    className="btn btn-danger"
                    onClick={handleDeleteConfirm}
                    data-bs-dismiss="modal"
                  >
                    Yes, Delete
                  </Link>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* /Delete Modal */}
    </>
  )
}

export default TransportModal
